import React from 'react';

const OrderToInvoice = () => {
  return (
    <div className="order-to-invoice">
      <div className="page-header">
        <h2>Sipariş → Fatura</h2>
        <p>Siparişleri faturaya çevirin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default OrderToInvoice; 